import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React, {memo} from 'react';
import MUIContainer from '@/components/MUI-Components/MUI-Container';
import {fadeInUp} from '@/animation/scroll-animation';
import Link from 'next/link';
import parse from 'html-react-parser';
import DisplayImage from '@/components/Ui-components/display-image';
import CommonCard from '@/components/Ui-components/home/common-card';
import {AnimatedComponent} from '@/components/Ui-components/AnimatedComponent';

const ExpertiseNetwork = (props: any) => {
    const {heading, subheading, contentData} = props;
    return (
        <Box>
            <MUIContainer>
                <Box textAlign="center" maxWidth={1024} margin="0 auto" mb={5}>
                    <Typography variant="h1" component="h2" mb={3} fontSize={{xs: 35, sm: 48}} className="font-headers">
                        {heading}
                    </Typography>
                    <Typography variant="subtitle1" className="remove-link-underline font-regular-text">
                        {subheading ? parse(subheading) : ''}
                    </Typography>
                </Box>
                <Box>
                    <Grid container spacing={4}>
                        {contentData?.map((item: any, index: number) => (
                            <Grid key={index + 1} item md={3} sm={6} xs={12}>
                                <AnimatedComponent variants={fadeInUp} delay={index * 0.2} className="height-full">
                                    <CommonCard>
                                        <Box textAlign="center">
                                            <DisplayImage alt={item.heading} src={item.src} />
                                            {item.redirect ? (
                                                <Typography variant="body1" mt={3}>
                                                    <Link
                                                        href={item.redirect}
                                                        target="_blank"
                                                        className="card-redirection-heading font-regular-text"
                                                    >
                                                        {item.heading}
                                                    </Link>
                                                </Typography>
                                            ) : (
                                                <Typography variant="body1" mt={1} className="font-regular-text">
                                                    {item.heading}
                                                </Typography>
                                            )}
                                        </Box>
                                    </CommonCard>
                                </AnimatedComponent>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </MUIContainer>
        </Box>
    );
};

export default memo(ExpertiseNetwork);
